// Hoe lang een video bewaard blijft. De termijn staat op één plek, in de backend
// (GET /api/video-analyses/bewaartermijn, uit de lifecycle-regel van de bucket); de toestemming,
// de privacy-uitleg en het rapport zetten hem hier in woorden.
import { useEffect, useState } from 'react';
import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const GETALLEN = ['', 'een', 'twee', 'drie', 'vier', 'vijf', 'zes', 'zeven', 'acht', 'negen', 'tien', 'elf', 'twaalf'];
const DAGEN_PER_MAAND = 365.25 / 12;

// 30 of 31 dagen is "een maand", 14 "twee weken", 365 "een jaar"; wat geen ronde termijn is, in dagen.
export function bewaartermijnInWoorden(dagen) {
  const maanden = Math.round(dagen / DAGEN_PER_MAAND);
  if (maanden >= 1 && maanden <= 12 && Math.abs(dagen - maanden * DAGEN_PER_MAAND) <= maanden) {
    if (maanden === 12) return 'een jaar';
    return `${GETALLEN[maanden]} ${maanden === 1 ? 'maand' : 'maanden'}`;
  }
  const weken = dagen / 7;
  if (Number.isInteger(weken) && weken <= 12) return `${GETALLEN[weken]} ${weken === 1 ? 'week' : 'weken'}`;
  return dagen === 1 ? 'een dag' : `${dagen} dagen`;
}

// Eén aanvraag voor alle onderdelen van de pagina; mislukt hij, dan probeert de volgende het opnieuw.
let aanvraag = null;
function haalBewaartermijn() {
  if (!aanvraag) {
    const jwt = localStorage.getItem('jwt');
    aanvraag = axios
      .get(`${STRAPI_URL}/api/video-analyses/bewaartermijn`, { headers: { Authorization: `Bearer ${jwt}` } })
      .then((res) => res.data.data.bewaartermijn_dagen)
      .catch((err) => {
        aanvraag = null;
        throw err;
      });
  }
  return aanvraag;
}

// { dagen, woorden } zodra de termijn er is, tot dan null.
export default function useVideoBewaartermijn() {
  const [dagen, setDagen] = useState(null);

  useEffect(() => {
    let actief = true;
    haalBewaartermijn()
      .then((d) => { if (actief) setDagen(d); })
      .catch((err) => console.error('Bewaartermijn ophalen mislukt:', err));
    return () => { actief = false; };
  }, []);

  return dagen ? { dagen, woorden: bewaartermijnInWoorden(dagen) } : null;
}
